import { useEffect } from 'react';
import { diagnosticsService } from '../services/diagnosticsService';

/**
 * Attach a labelled context entry to the current page for diagnostics reporting.
 * Use a stable `key` per mount point (e.g. "job", "customer") so repeat calls
 * from the same location update in place rather than stacking.
 *
 * Example:
 *   useDiagnosticsContext('job', job ? `Job ${job.jobNumber} — ${job.customerName}` : null);
 */
export function useDiagnosticsContext(key: string, label: string | null | undefined): void {
    useEffect(() => {
        diagnosticsService.setContext(key, label ?? null);
        return () => {
            diagnosticsService.setContext(key, null);
        };
    }, [key, label]);
}
